import React__default from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { SwanComboboxContextProvider } from './combobox.context.js';
import { FlexBox } from '../flex-box/flex-box.component.js';
import { CollectionContextProvider } from '../../contexts/internal/collection/collection.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';

const comboboxPropTypes = {};
const Combobox = renderWithRef('Combobox', comboboxPropTypes, (props, ref)=>{
    useComponentStylesLoaded('Combobox', [
        SWAN_STYLE_KEY_MAP.combobox,
        SWAN_STYLE_KEY_MAP.listbox,
        SWAN_STYLE_KEY_MAP.popover
    ]);
    const { children, className, items } = props;
    const classes = new Set();
    if (className) classes.add(className);
    return /*#__PURE__*/ React__default.createElement(FlexBox, {
        className: Array.from(processStyleProps(props, classes)).join(' '),
        ref: ref
    }, /*#__PURE__*/ React__default.createElement(CollectionContextProvider, {
        items: items
    }, /*#__PURE__*/ React__default.createElement(SwanComboboxContextProvider, props, children)));
});

export { Combobox, comboboxPropTypes };
